import { AvaiableStateForRequirement } from '../../models/state-requirement.model';
import { createAction, props } from '@ngrx/store';
import { ProfileRequirement } from '../../models/profile-requirements.model';
import { FetchArgs } from 'src/app/shared/models/core';

export const getAvailableStatesForRequirements = createAction(
    '[STATE REQUIREMENT] Get Available States for Requirements',
    props<{ filter: FetchArgs }>()
);

export const getAvailableStatesForRequirementsFailure = createAction(
    '[STATE REQUIREMENT] Get Available for Requirements States Failure',
    props<{ error: any }>()
);

export const getAvailableStatesForRequirementsSuccess = createAction(
    '[STATE REQUIREMENT] Get Available for Requirements States Success',
    props<{ states: AvaiableStateForRequirement[] }>()
);

export const getStateGlobalRequirements = createAction(
    '[STATE REQUIREMENT] Get Global State Requirements',
    props<{ stateId: number; filter: FetchArgs }>()
);

export const setFilterStateGlobalRequirements = createAction(
    '[STATE REQUIREMENT] Set Global Filter State Requirements',
    props<{ stateId: number; filter: FetchArgs }>()
);

export const getStateGlobalRequirementsFailure = createAction(
    '[STATE REQUIREMENT] Get Global State Requirements Failure',
    props<{ error: any }>()
);

export const getStateGlobalRequirementsSuccess = createAction(
    '[STATE REQUIREMENT] Get Global State Requirements Success',
    props<{ requirements: ProfileRequirement[] }>()
);
